// extracted by mini-css-extract-plugin
export default {"panel":"panel--WQ_vg"};